import React, { useState, useEffect } from 'react';
import { Container, Card, Menu, Input,  Grid } from 'semantic-ui-react';

import { PageTitle } from '../common/PageTitle';
import { CardSong } from '../cards/CardSong';
import { ResultContainerpages } from '../search/ResultContainerpages';

export const BrowseSongs = () => {
  const url = '/go/api/v1/songs/search?size=120';
  const [songs, setSongs] = useState([]);
  const size = 90;
  const [aliases, setAliases] = useState({});
  const [query, setQuery] = useState('*');
  const [start, setStart] = useState(0);
  const [end, setEnd] = useState(size);
  const [activeTab, setActiveTab] = useState('songs');
  const [searchTerm, setSearchTerm] = useState('');

  

  useEffect(() => {
    async function go() {
      const result = await fetch(url);
      const json = await result.json();
      console.debug(json);
    }
    go();
  }, []);

  useEffect(() => {
  const timer = setTimeout(() => {
    setQuery(searchTerm.trim() === '' ? '*' : searchTerm);
  }, 300); 

    return () => clearTimeout(timer);
  }, [searchTerm]);


  return (
    <React.Fragment>
      <PageTitle title='Songs' name='songs'>
      Browse our collection of songs.
      </PageTitle>
      <Container id='songs'>
        <Grid>
          <Grid.Column width={4}>
            <Menu vertical secondary>
              <Menu.Item>
                <Input type='search' placeholder='Search songs...' fluid value= {searchTerm} onChange={(e) => setSearchTerm(e.target.value)}/>
              </Menu.Item>
            </Menu> 
          </Grid.Column>
          <Grid.Column width={12}>
            <ResultContainerpages query={query} model={activeTab} aliases={aliases} start={start} end={end} size={size} />     
          </Grid.Column>
        </Grid>
      </Container>
    </React.Fragment>
  );
};
